export class SmartTableLastSearchOperation {
  searchType?: 'simple_search' | 'advanced_search';
  simpleSearchText?: string;
  simpleSearchOperator?: string;
  currentPage: number = 0;
  advancedSearchQuery?: string;
  advanceFilterFields: [];
  tableKey: string;
  rows: number = 10;
  first: number = 0;
}
